import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';

interface RemoveButtonProps {
  onClick: () => void;
  className?: string;
}

export function RemoveButton({ onClick, className }: RemoveButtonProps) {
  return (
    <Button type="button" variant="destructive" size="sm" onClick={onClick} className={className}>
      <X className="size-3.5" />
      Remove
    </Button>
  );
}
